<p-dialog maskStyleClass="backdrop-blur-sm" class="loader" [closable]="false" [focusOnShow]="false" (visibleChange)="onClose()" [(visible)]="visible" [draggable]="false" [resizable]="false" [breakpoints]="{ '1199px': '50vw', '575px': '90vw' }" [style]="{ width: '30vw' }" >
    <div class="logo">
        <div class="maschera"></div>
    </div>
</p-dialog>